import * as angular from "angular";
import * as _ from "lodash";
import {VehicleType} from "../../commons/types/vehicle.type";

export class VehiclesDialogService {

  public vehicleTypes = Object.values(VehicleType);

  /* @ngInject */
  constructor(private $mdDialog, private $log) {
  }

  // ******************************
  // External methods
  // ******************************

  createNewVehicleType(event, vehicle?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/vehicle-create-dialog.html').default,
      controller: function ($scope, splitService, VehiclesConstants, labelsService) {

        if(vehicle) {
          $scope.header = 'Edit Vehicle Type';
          $scope.submit = 'Update';
        }else{
          $scope.header = 'Create Vehicle Type';
          $scope.submit = 'Create';
        }

        $scope.weightConfig = splitService.getWeightUnit();
        $scope.volumeConfig = splitService.getVolumeUnit();
        $scope.distanceConfig = splitService.getSiteDistanceLargeUnit(true);
        $scope.vehicleTypes = self.vehicleTypes;
        $scope.vehiclePricingTypes = VehiclesConstants.vehiclePricingTypes;
        $scope.vehicleMakes = VehiclesConstants.makes;
        $scope.labelOptions = [];
        $scope.activeLabels = [];
        $scope.excludeLabelNames = [];
        $scope.vehicleMaxVolume = undefined;
        $scope.distancePerLiterInKm = undefined;

        $scope.labelTotals = {
          weight: 0,
          volume: 0
        };

        $scope.payload = vehicle || {
          name: undefined,
          type: undefined,
          make: undefined,
          model: undefined,
          doors: undefined,
          metersPerEnergyUnit: undefined,
          maxEnergyCapacity: undefined,
          pricing: {
            pricePerRoute: undefined,
            pricePerMeterTraveled: undefined,
            pricePerMinuteTraveled: undefined,
            pricePerMinuteWaiting: undefined,
            pricePerMinuteServiceTime: undefined,
          },
          vehicleCapacity: {
            numberOfPackages: undefined,
            numberOfDeliveries: undefined,
            numberOfDrops: undefined,
            weight: undefined,
            dimensions: {
              height: undefined,
              width: undefined,
              length: undefined
            },
            subCapacity: [],
            labels: []
          }
        };

        $scope.loading = true;

        labelsService.getAll()
            .then((labels) => {
              $scope.activeLabels = [];
              $scope.excludeLabelNames = [];
              $scope.labelOptions = _.uniqBy(labels, 'name');
            })
            .catch((error) => {
              self.$log(error)
            })
            .finally(() => {
              $scope.loading = false;
            });

        $scope.onVehicleDimensionsChange = onVehicleDimensionsChange;
        $scope.onVehicleWeightChange = onVehicleWeightChange;
        $scope.onLabelsChange = onLabelsChange;
        $scope.onRemoveSubCapacity = onRemoveSubCapacity;
        $scope.onUnlimitedDimensionsChange = onUnlimitedDimensionsChange;
        $scope.onAddLabel = onAddLabel;
        $scope.onWeightChange = onWeightChange;
        $scope.onVolumeChange = onVolumeChange;
        $scope.onDistancePerLiterChange = onDistancePerLiterChange;

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        function onVehicleDimensionsChange(dimensions) {
          const width = dimensions.width;
          const height = dimensions.height;
          const length = dimensions.length;

          dimensions.cube = width;

          // _resetLabelsDimensions();

          $scope.vehicleMaxVolume = (!width || !height || !length) ? undefined : (width * height * length);
        }

        function onVehicleWeightChange(weight) {
          // _resetLabelsWeight();
        }

        function onLabelsChange(labelNames, subCapacityItem) {
          subCapacityItem.labels = labelNames;

          const allLabels = _getAllVehicleLabels();
          $scope.payload.vehicleCapacity.labels = _.uniq(allLabels);
        }

        function onRemoveSubCapacity(subCapacityIndex) {
          $scope.payload.vehicleCapacity.subCapacity.splice(subCapacityIndex, 1);
          $scope.payload.vehicleCapacity.labels = _getAllVehicleLabels();

          _recalcLabelTotalWeight();
          _recalcLabelTotalVolume();
        }

        function onUnlimitedDimensionsChange(value) {
          if (!value) {
            $scope.payload.vehicleCapacity.dimensions = undefined;
          } else {
            $scope.payload.vehicleCapacity.dimensions = {
              height: 0,
              width: 0,
              length: 0
            }
          }
        }

        function onAddLabel() {

          if (!$scope.payload.vehicleCapacity.labels) {
            $scope.payload.vehicleCapacity.labels = [];
          }

          if (!$scope.payload.vehicleCapacity.subCapacity) {
            $scope.payload.vehicleCapacity.subCapacity = [];
          }

          $scope.payload.vehicleCapacity.subCapacity.push({
            labels: [],
            weight: undefined,
            dimensions: {
              height: undefined,
              width: undefined,
              length: undefined
            }
          });
        }

        function onWeightChange(subCapacityItem, weight, form) {
          subCapacityItem.weight = weight;
          _recalcLabelTotalWeight();
          form.weight.$setValidity('overWeight', $scope.payload.vehicleCapacity.weight ?
              ($scope.payload.vehicleCapacity.weight - $scope.labelTotals.weight) >= 0 : true);
        }

        function onVolumeChange(subCapacityItem, width, form) {
          if (width) {
            subCapacityItem.dimensions.height = 1;
            subCapacityItem.dimensions.length = 1;
          } else {
            subCapacityItem.dimensions = {
              height: undefined,
              width: undefined,
              length: undefined
            }
          }

          _recalcLabelTotalVolume();
          form.volume.$setValidity('overVolume', $scope.vehicleMaxVolume ?
              ($scope.vehicleMaxVolume - $scope.labelTotals.volume) >= 0 : true);
        }

        function onDistancePerLiterChange(distancePerLiterInKm) {
          $scope.payload.metersPerEnergyUnit = distancePerLiterInKm * 1000;
        }

        $scope.onSubmit = (form) => {
          form.$setSubmitted(true);

          if (form.$valid) {
            self.$mdDialog.hide($scope.payload);
          }
        }

        function _recalcLabelTotalWeight() {
          $scope.labelTotals.weight = _.sumBy($scope.payload.vehicleCapacity.subCapacity, (sc: any) => {
            return sc.weight || 0;
          });
        }

        function _recalcLabelTotalVolume() {
          $scope.labelTotals.volume = _.sumBy($scope.payload.vehicleCapacity.subCapacity, (sc: any) => {
            return sc.dimensions.width || 0;
          });
        }

        function _resetLabelsDimensions() {
          _.forEach($scope.payload.vehicleCapacity.subCapacity, (subCapacity) => {
            subCapacity.dimensions = {};
          });
          _recalcLabelTotalVolume();
        }

        function _resetLabelsWeight() {
          _.forEach($scope.payload.vehicleCapacity.subCapacity, (subCapacity) => {
            subCapacity.weight = undefined;
          });
          _recalcLabelTotalWeight();
        }

        function _getAllVehicleLabels() {
          return _.flatMap($scope.payload.vehicleCapacity.subCapacity, (sc) => {
            return sc.labels
          })
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  editVehicleInfo(vehicle, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-vehicle-info-dialog.html').default,
      controller: function ($scope, VehiclesConstants, splitService) {
        $scope.weightUnit = splitService.getWeightUnit()

        $scope.vehicleTypes = self.vehicleTypes;
        $scope.vehicleMakes = VehiclesConstants.makes;

        $scope.labelTotals = {
          weight: 0,
          volume: 0
        };

        $scope.vehicle = angular.copy(vehicle);

        $scope.distancePerLiterInKm = $scope.vehicle.metersPerEnergyUnit ? $scope.vehicle.metersPerEnergyUnit / 1000 : undefined;

        $scope.onDistancePerLiterChange = onDistancePerLiterChange;
        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        function onDistancePerLiterChange(distancePerLiterInKm) {
          $scope.vehicle.metersPerEnergyUnit = distancePerLiterInKm * 1000;
        }

        $scope.onSubmit = (form) => {
          form.$setSubmitted(true);

          if (form.$valid) {
            self.$mdDialog.hide($scope.vehicle);
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: false
    })
  }

  editVehicleCapacity(vehicle, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-vehicle-capacity-dialog.html').default,
      controller: function ($scope, VehiclesConstants, splitService, labelsService) {

        $scope.weightConfig = splitService.getWeightUnit();
        $scope.volumeConfig = splitService.getVolumeUnit();
        $scope.vehicle = angular.copy(vehicle);
        $scope.labelOptions = [];
        $scope.activeLabels = [];

        $scope.labelTotals = {
          weight: 0,
          volume: 0
        };

        $scope.vehicleMaxVolume = _getVehicleMaxVolume(vehicle.vehicleCapacity.dimensions);

        if (!$scope.vehicle.vehicleCapacity) {
          $scope.vehicle.vehicleCapacity = {
            numberOfPackages: undefined,
            numberOfDeliveries: undefined,
            numberOfDrops: undefined,
            weight: undefined
          }
        }

        if (!$scope.vehicle.vehicleCapacity.labels && $scope.vehicle.vehicleCapacity.subCapacity) {
          $scope.vehicle.vehicleCapacity.labels = _.map(vehicle.vehicleCapacity.subCapacity, (sc: any) => {
            return _.find(sc.labels, (l) => {
              return l.name === sc.labels[0];
            }).name;
          })
        }

        _.forEach($scope.vehicle.vehicleCapacity.subCapacity, (capacityItem) => {
          if (capacityItem.dimensions.width === 0) {
            capacityItem.dimensions.width = undefined;
          }
        });

        $scope.loading = true;
        labelsService.getAll()
          .then((labels) => {
            $scope.labelOptions = _.uniqBy(labels, 'name');
            if (!$scope.vehicle.vehicleCapacity.labels) {
              $scope.vehicle.vehicleCapacity.labels = _.map($scope.vehicle.vehicleCapacity.subCapacity, (sc) => {
                return _.find(labels, (l) => {
                  return l.name === sc.labels[0];
                })
              })
            }

            _recalcLabelTotalWeight();
            _recalcLabelTotalVolume();

          })
          .catch(function (error) {
          })
          .finally(function () {
            $scope.loading = false;
          });

        $scope.onVehicleDimensionsChange = onVehicleDimensionsChange;
        $scope.onUnlimitedDimensionsChange = onUnlimitedDimensionsChange;
        $scope.onVehicleWeightChange = onVehicleWeightChange;
        $scope.onLabelsChange = onLabelsChange;
        $scope.onAddLabel = onAddLabel;
        $scope.onRemoveSubCapacity = onRemoveSubCapacity;
        $scope.onWeightChange = onWeightChange;
        $scope.onVolumeChange = onVolumeChange;

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        function onVehicleDimensionsChange(dimensions) {
          dimensions.cube = dimensions.width;
          $scope.vehicleMaxVolume = _getVehicleMaxVolume(dimensions);
          // _resetLabelsDimensions();
        }

        function onUnlimitedDimensionsChange(value) {
          if (!value) {
            $scope.vehicle.vehicleCapacity.dimensions = undefined;
          } else {
            $scope.vehicle.vehicleCapacity.dimensions = {
              height: 0,
              width: 0,
              length: 0
            }
          }
        }

        function onVehicleWeightChange(weight) {
          // _resetLabelsWeight();
        }

        function onLabelsChange(labelNames, subCapacityItem) {
          subCapacityItem.labels = labelNames;

          var allLabels = _getAllVehicleLabels();
          $scope.vehicle.vehicleCapacity.labels = _.uniq(allLabels);
        }

        function onAddLabel() {
          if (!$scope.vehicle.vehicleCapacity.labels) {
            $scope.vehicle.vehicleCapacity.labels = [];
          }

          if (!$scope.vehicle.vehicleCapacity.subCapacity) {
            $scope.vehicle.vehicleCapacity.subCapacity = [];
          }
          $scope.vehicle.vehicleCapacity.subCapacity.push({
            labels: [],
            weight: undefined,
            dimensions: {
              height: undefined,
              width: undefined,
              length: undefined
            }
          });
        }

        function onRemoveSubCapacity(subCapacityIndex) {
          $scope.vehicle.vehicleCapacity.subCapacity.splice(subCapacityIndex, 1);
          $scope.vehicle.vehicleCapacity.labels = _getAllVehicleLabels();

          _recalcLabelTotalWeight();
          _recalcLabelTotalVolume();
        }

        function onWeightChange(subCapacityItem, weight, form) {
          subCapacityItem.weight = weight;
          _recalcLabelTotalWeight();

          form.weight.$setValidity('overWeight', $scope.vehicle.vehicleCapacity.weight ?
            ($scope.vehicle.vehicleCapacity.weight - $scope.labelTotals.weight) >= 0 : true);
        }

        function onVolumeChange(subCapacityItem, width, form) {
          if (width) {
            subCapacityItem.dimensions.height = 1;
            subCapacityItem.dimensions.length = 1;
          } else {
            subCapacityItem.dimensions = {
              height: undefined,
              width: undefined,
              length: undefined
            }
          }

          _recalcLabelTotalVolume();
          form.volume.$setValidity('overVolume', $scope.vehicleMaxVolume ?
            ($scope.vehicleMaxVolume - $scope.labelTotals.volume) >= 0 : true);
        }

        $scope.onSubmit = (form) => {
          form.$setSubmitted(true);

          if (form.$valid) {
            self.$mdDialog.hide($scope.vehicle);
          }
        }

        function _recalcLabelTotalWeight() {
          $scope.labelTotals.weight = _.sumBy($scope.vehicle.vehicleCapacity.subCapacity, (sc: any) => {
            return sc.weight || 0;
          });
        }

        function _recalcLabelTotalVolume() {
          $scope.labelTotals.volume = _.sumBy($scope.vehicle.vehicleCapacity.subCapacity, (sc: any) => {
            return sc.dimensions.width || 0;
          });
        }

        function _resetLabelsDimensions() {
          _.forEach($scope.vehicle.vehicleCapacity.subCapacity, (subCapacity) => {
            subCapacity.dimensions = {};
          });
          _recalcLabelTotalVolume();
        }

        function _resetLabelsWeight() {
          _.forEach($scope.vehicle.vehicleCapacity.subCapacity, (subCapacity) => {
            subCapacity.weight = undefined;
          });
          _recalcLabelTotalWeight();
        }

        function _getAllVehicleLabels() {
          return _.flatMap($scope.vehicle.vehicleCapacity.subCapacity, (sc) => {
            return sc.labels
          })
        }

        function _getVehicleMaxVolume(dimensions) {
          const width: number = _.get(dimensions, 'width');
          const height: number = _.get(dimensions, 'height');
          const length: number = _.get(dimensions, 'length');
          return (!width || !height || !length) ? undefined : (width * height * length);
        }

      },
      targetEvent: event,
      clickOutsideToClose: false
    })
  }

  vehicleSelect(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/vehicle-select-dialog.html').default,
      controller: function ($scope, $vehicles, $infiniteScroll) {

        const vehiclesRef = $vehicles(),
          loadLimit = 20;

        vehiclesRef.$query({limit: loadLimit, sortByLoad: true, active: true});
        $scope.infiniteScroll = $infiniteScroll(vehiclesRef, loadLimit);

        $scope.cancel = self.$mdDialog.cancel;
        $scope.onAddVehicle = onAddVehicle;
        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        function onAddVehicle(vehicle) {
          if (vehicle) {
            this.$mdDialog.hide(vehicle);
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  addVehicles(event, excludeIds, branchId) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-vehicles-dialog.html').default,
      controller: function ($scope, $vehicles, $infiniteScroll) {

        const vehiclesRef = $vehicles(),
          loadLimit = 20;

        $scope.vehicleChips = [];
        $scope.queryString = undefined;
        $scope.excludeIds = excludeIds ? angular.copy(excludeIds) : [];

        vehiclesRef.$query(_getQueryPayload());
        $scope.infiniteScroll = $infiniteScroll(vehiclesRef, loadLimit);

        $scope.cancel = self.$mdDialog.cancel;
        $scope.onQueryChange = onQueryChange;
        $scope.onAdd = onAdd;
        $scope.onRemove = onRemove;
        $scope.onClear = onClear;
        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        function onQueryChange(query) {
          $scope.queryString = query;
          _query();
        }

        function onAdd(vehicle) {
          if (vehicle) {
            const vehicleChip = {
              id: vehicle.name,
              name: vehicle.name,
              vehicleRef: vehicle
            };
            $scope.vehicleChips.push(vehicleChip);
            $scope.excludeIds.push(vehicle.name);
            $scope.vehicleChips = _.uniqBy($scope.vehicleChips, 'name');
          }
        }


        function onRemove(chip) {
          $scope.excludeIds = _.filter($scope.excludeIds, (id) => {
            return id !== chip.id;
          });
        }

        function onClear() {
          $scope.excludeIds = angular.copy(excludeIds);
          $scope.vehicleChips = [];
        }

        $scope.onSubmit = () => {
          if ($scope.vehicleChips.length) {
            const vehicles = _.map($scope.vehicleChips, (v) => {
              return v.vehicleRef
            });
            self.$mdDialog.hide(vehicles);
          }
        }


        function _query() {
          vehiclesRef.$query(_getQueryPayload())
            .then(() => {
              $scope.infiniteScroll.reload();
            })
            .catch((error) => {
              this.$log.error('Fail to $query', error);
            })
        }

        function _getQueryPayload() {
          return {
            limit: loadLimit,
            sortByLoad: true,
            active: true,
            query: $scope.queryString,
            branchIds: branchId ? [branchId] : undefined
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

}

angular
  .module('bringoz.admin.vehicles')
  .service('vehiclesDialogService', VehiclesDialogService);
